import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => mergeStyleSets({
  mappingManager: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '20px 12px 0 12px',
  },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& .input': {
      flexGrow: 1,
    },
  },
  separator: {
    margin: '-12px 0',
  },
  constants: {
    width: '100%',
    '& button': {
      width: '100%',
    }
  },
  fixedBottomPanel: {
    position: 'sticky',
    bottom: 0,
    width: '100%',
    padding: '15px 12px 20px 12px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
  }
});
